// UI / orderReducer.js
import * as types from './orderActionTypes';

const initialState = {
  orderList: [],
  orderData: null,
  isLoading: false,
  error: null,
  addOrderData: null,
  updateOrderData: null,
  deleteOrderData: null,
  orderDetailsData: null,
  orderDetailsError: null,
  orderActionData: null,
  orderActionError: null,
  updateSwapStockData: null,
  updateSwapStockError: null,
  updateSwapShipmentData: null,
  updateSwapShipmentError: null,
  // Pagination alanları
  totalCount: 0,
  pageNumber: 1,
  pageSize: 10,
  totalPages: 0,
  hasPreviousPage: false,
  hasNextPage: false,
};

export const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ORDER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.GET_ORDER_SUCCESS:
      return { 
        ...state, 
        isLoading: false, 
        orderList: action.payload?.OrderList || [],
        // Pagination bilgilerini response'dan al
        totalCount: action.payload?.TotalCount || 0,
        pageNumber: action.payload?.PageNumber || 1,
        pageSize: action.payload?.PageSize || 10,
        totalPages: action.payload?.TotalPages || 0,
        hasPreviousPage: action.payload?.HasPreviousPage || false,
        hasNextPage: action.payload?.HasNextPage || false,
        error: null 
      };
    case types.GET_ORDER_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.ADD_ORDER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.ADD_ORDER_SUCCESS:
      return { ...state, isLoading: false, addOrderData: action.payload, error: null };
    case types.ADD_ORDER_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.UPDATE_ORDER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.UPDATE_ORDER_SUCCESS:
      return { ...state, isLoading: false, updateOrderData: action.payload, error: null };
    case types.UPDATE_ORDER_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.DELETE_ORDER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.DELETE_ORDER_SUCCESS:
      return { ...state, isLoading: false, deleteOrderData: action.payload, error: null };
    case types.DELETE_ORDER_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.GET_ORDER_DETAILS_REQUEST:
      return { ...state, isLoading: true, orderDetailsError: null };
    case types.GET_ORDER_DETAILS_SUCCESS:
      return { ...state, isLoading: false, orderDetailsData: action.payload,
         orderDetailsError: null };
    case types.GET_ORDER_DETAILS_ERROR:
      return { ...state, isLoading: false, orderDetailsError: action.payload };

    case types.ORDER_ACTION_REQUEST:
      return { ...state, isLoading: true, orderActionError: null };
    case types.ORDER_ACTION_SUCCESS:
      return { ...state, isLoading: false, orderActionData: action.payload, 
        orderActionError: null };
    case types.ORDER_ACTION_ERROR:
      return { ...state, isLoading: false, orderActionError: action.payload };

    case types.UPDATE_SWAP_STOCK_REQUEST:
      return { ...state, isLoading: true, updateSwapStockError: null };
    case types.UPDATE_SWAP_STOCK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        updateSwapStockData: action.payload,
        updateSwapStockError: null,
      };
    case types.UPDATE_SWAP_STOCK_ERROR:
      return { ...state, isLoading: false, updateSwapStockError: action.payload };

    case types.UPDATE_SWAP_SHIPMENT_REQUEST:
      return { ...state, isLoading: true, updateSwapShipmentError: null };
    case types.UPDATE_SWAP_SHIPMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        updateSwapShipmentData: action.payload,
        updateSwapShipmentError: null,
      };
    case types.UPDATE_SWAP_SHIPMENT_ERROR:
      return { ...state, isLoading: false, updateSwapShipmentError: action.payload };

    default:
      return state;
  }
}; 